import { Button, Modal } from "antd";
import React from "react";
import iconError from "../../../assets/images/popup-icon-error.svg";
import { Utilities } from "../../../core/helpers/utilities";
import { ErrorDto } from "../../../core/models/dtos/error.dto";
import "./SubErrorModal.scss";

interface IProps {
  apiError?: ErrorDto;
  resetApiError: () => void;
}

const SubErrorModal = (props: IProps) => {
  const isErrorDialog = (): boolean => {
    return !!props.apiError && !Utilities.isPushTokenError(props.apiError);
  };

  const getTitle = (): string => {
    if (props.apiError) {
    }
    return "";
  };

  const getText = (): string => {
    if (props.apiError) {
      if (props.apiError.path === "/payment/pay-tr/delete-card") {
        return props.apiError.message;
      }

      if (props.apiError.path === "/payment/pay-tr/start") {
        return props.apiError.message;
      }
    }
    return "";
  };

  return (
    <Modal
      className="sub-error-modal"
      maskStyle={{ backdropFilter: "blur(8px)" }}
      visible={isErrorDialog()}
      centered
      closable={false}
      footer={false}
      onCancel={props.resetApiError}
      destroyOnClose
    >
      <div className="body">
        <div className="header">
          <span className="title">{getTitle()}</span>
          <img className="logo" src={iconError} alt="error" />
        </div>

        <p className="text">{getText()}</p>

        <Button className="button" onClick={props.resetApiError}>
          Tamam
        </Button>
      </div>
    </Modal>
  );
};

export { SubErrorModal };
